import React from "react";
import { ListenerContext } from "types/listener";

export const Context = React.createContext<ListenerContext | null>(null);

export default Context;
